// extracted by css-extract-rspack-plugin
export default {"ModalParent":"ModalParent-xHUBwl","modalParent":"ModalParent-xHUBwl"};